import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import "./App.css";
import AuthPage from "./pages/auth";

import { UserProvider } from "./context/useAuth";
import ProtectedRoute from "./routes/ProtectedRoutes";
import "react-datepicker/dist/react-datepicker.css";
import Dashboard from "./pages/dashboard";
import UserPage from "./pages/dashboard/user";

function App() {
  return (
    <Router>
      <UserProvider>
        <Routes>
          <Route path="/" Component={AuthPage} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/users"
            element={
              <ProtectedRoute>
                <UserPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </UserProvider>
    </Router>
  );
}

export default App;
